import React from 'react';
import ReactLoading from 'react-loading';

function Loading() {
    return (
        <ReactLoading
            className="gympoint-loading"
            type="bars"
            color="#EE4C65"
        />
    );
}

export default Loading;
